import { useState } from 'react'
import translations from '../translations/en.json'

interface IClipboard {
  clipboard?: string
  isCoping: boolean
  isCopied: boolean
  isError: boolean
  error?: Error
  copy: (text: string) => Promise<void>
}

export const useClipboard = (): IClipboard => {
  const [isCopied, setIsCopied] = useState<boolean>(false)
  const [timeoutId, setTimeoutId] = useState<number>(0)
  const [{ isCoping, clipboard, isError, error }, setState] = useState<
    Omit<IClipboard, 'copy' | 'isCopied'>
  >({
    isCoping: false,
    isError: false,
  })
  const copy = async (text: string) => {
    setState({
      isCoping: false,
      isError: false,
    })
    try {
      await navigator.clipboard.writeText(text)
      setState({
        isCoping: false,
        isError: false,
        clipboard: text,
      })
      setIsCopied(true)
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
      setTimeoutId(
        window.setTimeout(() => {
          setIsCopied(false)
        }, 3000),
      )
    } catch (e) {
      setState({
        isCoping: false,
        isError: true,
        error: new Error(
          (e instanceof Error ? e.message : '') || translations['error.default_toast_message'],
        ),
      })
    }
  }
  return {
    clipboard,
    isCopied,
    isCoping,
    isError,
    error,
    copy,
  }
}
